import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import styles from './UpgradeAccountButton.module.css'

const UpgradeAccountButton = ({ className, currentUser }) =>
  <button
    className={classNames('btn', 'btn-primary', styles.button, className)}
    onClick={() => {
      alert(
        'You cannot upgrade your account at this moment, please contact support@mydiamondrevolution.com for help. Sorry for the inconvenience.'
      )
    }}
  >
    Upgrade Account
  </button>

const mapStateToProps = ({ login }) => ({
  currentUser: login.get('currentUser')
})

export default connect(mapStateToProps)(UpgradeAccountButton)
